<template>
  <section class="about-us">
    <div class="decor-blob-1"></div>
    <div class="decor-blob-2"></div>

    <div class="container">
      <section class="about-us-block">
        <div class="content-wrapper" data-aos="fade-left">
          <div class="header-group">
            <span class="sub-heading">{{ $t('originWhoWeAre') }}</span>
            <h2 class="section-title">{{ $t('originStoryTitle') }}</h2>
          </div>
          <p class="lead-text">{{ $t('originStoryParagraphOne') }}</p>
          <div class="body-text-container">
             <p class="body-text">{{ $t('originStoryParagraphTwo') }}</p>
             </div>
        </div>
      </section>
      <section class="about-grid reverse">
        <div class="content-wrapper" data-aos="fade-right">
          <div class="header-group">
            <span class="sub-heading">{{ $t('originOurMission') }}</span>
            <h3 class="h2-style">{{ $t('originStoryMissionTitle') }}</h3>
          </div>
          <div class="body-text-container">
            <p class="body-text">{{ $t('originStoryParagraphFive') }}</p>
            <p class="body-text">{{ $t('originStoryParagraphSix') }}</p>
          </div>
          <ul class="custom-list">
            <li>
              <div class="check-box">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
              </div>
              <span>{{ $t('originMissionPoint_1') }}</span>
            </li>
            <li>
              <div class="check-box">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
              </div>
              <span>{{ $t('originMissionPoint_2') }}</span>
            </li>
            <li>
              <div class="check-box">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
              </div>
              <span>{{ $t('originMissionPoint_3') }}</span>
            </li>
          </ul>
        </div>
        <div class="image-wrapper" data-aos="fade-right">
          <div class="image-inner">
            <img src="@/assets/images/about_us/arkayl_about_us.jpg" alt="Echipa Arkayl" class="main-img" />
            <div class="experience-badge glass-effect">
              <span class="number">5+</span>
              <span class="label">{{ $t('yearsOf') }}<br>{{ $t('expertise') }}</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<style scoped>

.about-us-block {
  margin-bottom: 100px;
}

  .body-text {
  line-height: 1.8;
  margin-bottom: 20px;
  color: #4a5568;
}

.h2-style {
  font-size: 3rem;
  margin: 0;
  line-height: 1.1;
  color: var(--primary-color);
  font-family: var(--secondary-font);
  text-transform: uppercase;
}

.experience-badge.glass-effect {
  background: rgba(6, 45, 69, 0.9);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.custom-list {
  margin-top: 40px;
}

.custom-list li {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 18px;
  font-size: 1.05rem;
  font-weight: 500;
}

.check-box {
  width: 24px;
  height: 24px;
  background: var(--secondary-color);
  color: white;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  flex-shrink: 0;
}

.main-img {
  transition: transform 0.5s ease, box-shadow 0.5s ease;
}

.image-inner:hover .main-img {
  transform: translateY(-10px);
  box-shadow: 0 40px 80px rgba(6, 45, 69, 0.15);
}

@media (max-width: 992px) {
  .h2-style { font-size: 2.2rem; }
}

.about-us {
  position: relative;
  overflow: hidden;
  background-color: #F7F9FC;
}

.decor-blob-1, .decor-blob-2 {
  position: absolute;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  z-index: 0;
  filter: blur(100px);
  pointer-events: none;
}
.decor-blob-1 { top: -10%; right: -5%; background: rgba(43, 189, 211, 0.08); }
.decor-blob-2 { bottom: 10%; left: -5%; background: rgba(6, 45, 69, 0.05); }

.about-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 80px;
  align-items: center;
  margin-bottom: 120px;
}

.image-inner {
  position: relative;
  z-index: 2;
}

.main-img {
  width: 100%;
  height: auto;
  border-radius: 40px;
  box-shadow: 0 30px 60px rgba(6, 45, 69, 0.1);
  display: block;
  object-fit: cover;
}

.experience-badge {
  position: absolute;
  bottom: -20px;
  right: -20px;
  background: var(--primary-color);
  color: white;
  padding: 25px 35px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 20px 40px rgba(6, 45, 69, 0.25);
}

.experience-badge .number {
  font-size: 2.5rem;
  font-weight: 800;
  font-family: var(--secondary-font);
  line-height: 1;
  color: var(--secondary-color);
}

.experience-badge .label {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 1.2;
}

.header-group {
  margin-bottom: 30px;
}

.sub-heading {
  color: var(--secondary-color);
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 2px;
  font-size: 0.9rem;
  display: inline-block;
  margin-bottom: 10px;
}

.section-title {
  margin: 0;
  line-height: 1.1;
  color: var(--primary-color);
}

.lead-text {
  font-size: 1.15rem;
  color: var(--primary-color);
  font-weight: 500;
  margin-bottom: 25px;
  opacity: 0.9;
}

.body-text {
  color: var(--text-color);
  opacity: 0.8;
  margin-bottom: 20px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 20px;
  background: #ffffff;
  border-radius: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(0,0,0,0.03);
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.05);
}

.icon-box {
  width: 50px;
  height: 50px;
  background: var(--primary-color);
  color: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  flex-shrink: 0;
}

.feature-title {
  margin: 0 0 5px 0;
  font-size: 1.1rem;
  color: var(--primary-color);
}

.small-desc {
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.7;
}

.custom-list {
  list-style: none;
  padding: 0;
  margin-top: 30px;
}

.custom-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  font-weight: 600;
  color: var(--primary-color);
}

.check-icon {
  width: 10px;
  height: 10px;
  background: var(--secondary-color);
  border-radius: 50%;
  flex-shrink: 0;
}

@media (min-width: 769px) {
  .about-grid {
    grid-template-columns: 1fr 1fr;
  }
  .about-grid.reverse .image-wrapper {
    order: 1;
  }
  .about-grid.reverse .content-wrapper {
    order: 2;
    padding-right: 50px;
  }
}

@media (max-width: 768px) {
  .section-title { font-size: 2.2rem; }
  .experience-badge {
    position: relative;
    right: 0;
    bottom: 0;
    margin-top: -30px;
    margin-left: 20px;
    display: inline-flex;
  }
  .about-grid.reverse .image-wrapper {
    order: 1;
  }
  .about-grid.reverse .content-wrapper {
    order: 2;
  }
}
</style>
